import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '@styles';

export const useStyles = makeStyles(() =>
  createStyles({
    personalizationPanel: {
      backgroundColor: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      // height: `calc(100% - ${variables.topBar.height})`,
      // height: `calc(100% - ${variables.topBar.height} + 0.8rem)`,
      maxHeight: 'calc(100% - 3.2rem)',
      minHeight: '27.5rem',
      padding: '2rem 1.6rem',
      width: '44.8rem',

      ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        width: '27rem', // 27rem comes from the width of the right side panel on a narrow display
      },
    },
  }),
);
